import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './i18n';
import './styles/global.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import CookieBanner from './components/CookieBanner';
import Home from './pages/Home';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Cookies from './pages/Cookies';
import Marketplace from './pages/Marketplace';
// Onboarding (autocadastro) desativado durante o foco B2B — página mantida, rota removida.
// Para reativar: descomentar o import e a rota /welcome abaixo.
// import Onboarding from './pages/Onboarding';
import SharedResult from './pages/SharedResult';
import PublicAgent from './pages/PublicAgent';
import PricingPage from './pages/PricingPage';
import CategoryPage from './pages/CategoryPage';
import Health from './pages/Health';
import Blog from './pages/Blog';
import BlogArticle from './pages/BlogArticle';
import HreflangMeta from './components/HreflangMeta';
import { initAnalytics, trackPageView } from './analytics';

function RouteTracker() {
  const location = useLocation();
  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);
  return null;
}

export default function App() {
  useEffect(() => {
    initAnalytics();
  }, []);

  return (
    <HelmetProvider>
      <BrowserRouter>
        <RouteTracker />
        <HreflangMeta />
        <Navbar />
        <Routes>
          <Route path="/"              element={<Home />} />
          <Route path="/terms"         element={<Terms />} />
          <Route path="/privacy"       element={<Privacy />} />
          <Route path="/cookies"       element={<Cookies />} />
          <Route path="/precos"              element={<PricingPage />} />
          <Route path="/saude"               element={<Health />} />
          <Route path="/agentes"            element={<Marketplace />} />
          <Route path="/agentes/categoria/:category" element={<CategoryPage />} />
          <Route path="/blog"                element={<Blog />} />
          <Route path="/blog/:slug"          element={<BlogArticle />} />
          {/* Autocadastro desativado (foco B2B) — reativar junto com o import de Onboarding:
          <Route path="/welcome"             element={<Onboarding />} /> */}
          <Route path="/r/:shareId"          element={<SharedResult />} />
          <Route path="/u/:userSlug/:agentSlug" element={<PublicAgent />} />
        </Routes>
        <Footer />
        <CookieBanner />
      </BrowserRouter>
    </HelmetProvider>
  );
}
